import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: true,
  selector: 'dcc-search-button',
  template: `
    <button class="lx-btn lx-btn-negative" (click)="onClick()">Search</button>
  `,
  styleUrls: ['../buttons.scss'],
})
export class SearchButtonComponent {
  @Input() disabled = false;

  @Output() search: EventEmitter<void> = new EventEmitter();

  onClick() {
    this.search.emit();
  }
}
